import gql from 'graphql-tag';

export const GetJobTitles = gql`
  query getJobTitles {
    getJobTitles {
      id
      name
      job_category_id
    }
  }
`;

export const GetJobs = gql`
  query getJobs {
    getJobs {
      id
      job_id
      job_title {
        id
        name
      }
      alternate_title
      hirevue_position_id
      active_candidates_count
      linked_jobs_count
      updated_on
      is_active
      job_description_document_url
      job_description_document_name
      client_ids
      clients {
        id
        name
      }
    }
  }
`;

export const GetJobDetails = gql`
  query getJobDetails($jobId: ID!) {
    getJobDetails(jobId: $jobId) {
      id
      job_id
      job_title {
        id
        name
        job_category_id
      }
      alternate_title
      hirevue_position_id
      active_candidates_count
      created_on
      updated_on
      is_active
      job_description_document_url
      job_description_document_name
      client_ids
      clients {
        id
        name
      }
    }
  }
`;

export const GetLinkedJobs = gql`
  query getClientJobSummaries($jobId: ID!) {
    getClientJobSummaries(jobId: $jobId) {
      id
      job_id
      workspace_id
      job_title
      alternate_title
      status
      no_of_positions
      no_of_positions_filled
      active_candidates_count
      office_location
      work_location_type_preferences
      shore_type_preferences
      client {
        id
        name
      }
    }
  }
`;

export const GetAvailablePrescreens = gql`
  query getAvailablePrescreens($jobId: ID!, $candidateId: ID) {
    getAvailablePrescreens(jobId: $jobId, candidateId: $candidateId) {
      id
      linked_job_id
      job_title
      alternate_title
      hirevue_position_id
      client {
        id
        name
      }
    }
  }
`;

export const GetLinkedJobDetail = gql`
  query getClientJobDetail($clientJobId: ID!) {
    getClientJobDetail(clientJobId: $clientJobId) {
      id
      job_id
      workspace_id
      job_title {
        id
        name
      }
      alternate_title
      status
      location {
        name
        street
        city
        state
        country
        zipcode
      }
      category {
        id
        name
      }
      duration {
        value
        type_name
      }
      employment_type {
        id
        data
      }
      no_of_positions
      no_of_positions_filled
      max_bill_rate
      work_location_type_preferences {
        id
        work_location_type_name
      }
      shore_type_preferences {
        id
        shore_type_name
      }
      skills {
        id
        name
      }
      job_description
      key_responsibilities
      vendor_notes
      milestones {
        title
        date
        isComplete
        isOngoing
      }
      client {
        id
        name
      }
    }
  }
`;

export const GetLinkableClientJobs = gql`
  query getLinkableClientJobs($jobId: ID!, $workspaceId: ID!) {
    getLinkableClientJobs(jobId: $jobId, workspaceId: $workspaceId) {
      id
      job_id
      job_title
      alternate_title
    }
  }
`;

export const LinkClientJob = gql`
  mutation linkClientJob($input: ClientJobInput!) {
    linkClientJob(input: $input) {
      id
      job_id
      client_job_id
      client_id
    }
  }
`;

export const UnlinkClientJob = gql`
  mutation unlinkClientJob($input: UnlinkClientJobInput!) {
    unlinkClientJob(input: $input)
  }
`;

export const GetFutureJobs = gql`
  query getFutureJobs {
    getFutureJobs {
      id
      job_title {
        id
        name
      }
      client_ids
      clients {
        id
        name
      }
      estimated_roles
      estimated_timing
      office_location
      shore_type_ids
      shore_types {
        id
        name
      }
      work_location_type_ids
      work_location_types {
        id
        name
      }
      job_description_document_url
      job_description_document_name
      is_active
      updated_on
    }
  }
`;

export const EditFutureJob = gql`
  mutation editFutureJob($id: ID!, $input: FutureJobInput!) {
    editFutureJob(id: $id, input: $input) {
      id
    }
  }
`;

export const CreateFutureJob = gql`
  mutation createFutureJob($input: FutureJobInput!) {
    createFutureJob(input: $input) {
      id
    }
  }
`;

export const CreateNewJob = gql`
  mutation createJob($input: JobInput) {
    createJob(input: $input) {
      message
      result {
        id
      }
      success
      error
    }
  }
`;

export const editJob = gql`
  mutation editJob($input: JobEditInput) {
    editJob(input: $input) {
      message
      result {
        id
      }
      success
      error
    }
  }
`;

export const jobActivation = gql`
  mutation jobActivation($input: JobActivation) {
    jobActivation(input: $input)
  }
`;

export const checkIfJobExist = gql`
  query checkIfJobExist($job_title_id: ID, $alternate_title: String) {
    checkIfJobExist(job_title_id: $job_title_id, alternate_title: $alternate_title)
  }
`;

export const getAllJobCategory = gql`
  query getAllJobCategory {
    getAllJobCategory {
      id
      name
      description
    }
  }
`;
